import type {
  ComputeExpression,
  IAdvancedRichText,
  IComputedWidget,
  WidgetType,
} from '@framework/engine';

export const WidgetTypeBurden = 'burden' as WidgetType.Burden;

/**
 * Configurazione Onere
 */
export interface IBurdenWidget extends IComputedWidget {
  id: string;
  type: WidgetType.Burden;
  label?: IAdvancedRichText;
  expression: ComputeExpression;
  macroBurdenTypeId: string;
  macroBurdenType: object;
}
